<div class="left-modal">
  <div class="close" (click)="close()"></div>
  <div class="modal-container">
    <h1>{{'Order table' | translate}}</h1>
  </div>
  <div class="row">
    <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
      @for (col of viewOrderItems; track col; let i = $index) {
        <div class="L-12 M-12 S-12 columns">
          <div class="tableColumnOrder">
            <div class="order">
              @if (!minNumber || col.old_order >= minNumber) {
                <input type="text" name="{{'order_' + i}}" [(ngModel)]="col.order" (blur)="changeOrder(col, i)" pattern="[0-9]{1,2}">
              }
              @if (minNumber &&  col.old_order < minNumber) {
                <p>{{col.order}}</p>
              }
            </div>
            {{col.name | translate}}
            @if ((!minNumber || col.order >= minNumber) && !col.isFilterActive) {
              <label class="switch">
                <input type="checkbox" name="{{'visible_' + i}}" [(ngModel)]="col.visible" >
                <span class="slider round"></span>
              </label>
            }
          </div>
        </div>
      }

      <div class="L-12 M-12 S-12 columns TextCentered">
        <input name="sumbit" type="submit" value="{{'Confirm' | translate}}">
      </div>
      <div class="L-12 M-12 S-12 columns TextCentered">
        <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
      </div>
    </form>
  </div>
</div>
